// Routes Configuration
// מיפוי נתיבים לכל דף באפליקציה

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  OBJECT_LIST: '/object/:objectName',
  RECORD_DETAIL: '/object/:objectName/:recordId',
  SETUP: '/setup',
  SETUP_SECTION: '/setup/:section',
  SETUP_OBJECT: '/setup/objects/:objectName',
  SETUP_OBJECT_TAB: '/setup/objects/:objectName/:tab',
};

// Mobile Routes
export const MOBILE_ROUTES = {
  HOME: '/mobile',
  LOGIN: '/mobile/login',
  OBJECT_LIST: '/mobile/object/:objectName',
  RECORD_DETAIL: '/mobile/object/:objectName/:recordId',
  PROFILE: '/mobile/profile',
};

// Helper functions לבניית URLs
export const buildObjectListUrl = (objectName) => `/object/${objectName}`;
export const buildRecordUrl = (objectName, recordId) => `/object/${objectName}/${recordId}`;
export const buildSetupUrl = (section = '', objectName = '', tab = '') => {
  if (objectName && tab) {
    return `/setup/objects/${objectName}/${tab}`;
  } else if (objectName) {
    return `/setup/objects/${objectName}`;
  } else if (section) {
    return `/setup/${section}`;
  }
  return '/setup';
};

// Mobile URL builders
export const buildMobileObjectListUrl = (objectName) => `/mobile/object/${objectName}`;
export const buildMobileRecordUrl = (objectName, recordId) => `/mobile/object/${objectName}/${recordId}`;
